import { theme, ThemeConfig } from 'antd';

/**
 * Get Ant Design theme configuration based on dark mode
 * @param isDarkMode - Whether dark mode is enabled
 * @returns Ant Design ThemeConfig object
 */
export const getAntdThemeConfig = (isDarkMode: boolean): ThemeConfig => {
  return {
    algorithm: isDarkMode ? theme.darkAlgorithm : theme.defaultAlgorithm,
    token: isDarkMode
      ? {
          colorBgElevated: '#1a202c',
          colorText: '#fff',
          colorTextSecondary: '#8c8c8c',
          controlItemBgHover: '#4a5568',
          controlItemBgActive: '#4a5568',
          controlItemBgActiveHover: '#4a5568',
        }
      : undefined,
    components: {
      Input: isDarkMode
        ? {
            colorBgContainer: '#2d3748',
            colorText: '#f7fafc',
            colorTextPlaceholder: 'rgba(255, 255, 255, 0.45)',
            colorBorder: '#4a5568',
            colorPrimary: '#63b3ed',
          }
        : undefined,
      InputNumber: isDarkMode
        ? {
            colorBgContainer: '#2d3748',
            colorText: '#f7fafc',
            colorTextPlaceholder: 'rgba(255, 255, 255, 0.45)',
            colorBorder: '#4a5568',
            colorPrimary: '#63b3ed',
          }
        : undefined,
      Select: isDarkMode
        ? {
            optionSelectedBg: '#4a5568',
            optionActiveBg: '#4a5568',
            optionPadding: '10px 12px',
          }
        : undefined,
    },
  };
};

